// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataEditTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 5H5v3h13zM3 5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v3.035a2.489 2.489 0 0 0-1.35.697L17.385 10H15v2.385l-2 2V10h-3v7.387l-.14.14c-.26.26-.469.564-.618.898L8.538 20H5a2 2 0 0 1-2-2V7zm5 5H5v8h3zm12.064.145a.5.5 0 0 1 .707 0l1.084 1.085a.5.5 0 0 1 0 .707l-1.069 1.068-1.791-1.791zm-6.998 10.586c-.088.088-.19.158-.304.208l-2.368 1.051a.32.32 0 0 1-.386-.38v-.005l1.058-2.364c.05-.112.12-.214.207-.301l7.01-7.014 1.792 1.792z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataEditTable;
